import React, { useContext } from 'react';
import { SideBar } from '@eposnow/ui-core';
import { Toolbar, useTheme } from '@mui/material';
import { UIContext } from '../../../../context/UIContext';
import { SidekickTablesContext } from '../helpers/SidekickTablesContext';

const EditSidebar = () => {
  const theme = useTheme();
  const { isMobile, animationsDisabled, iOS } = useContext(UIContext);

  const { EditComponent, objectBeingEdited, resetCurrentEditObject } =
    useContext(SidekickTablesContext);

  if (!EditComponent || !objectBeingEdited || !isMobile) {
    return null;
  }

  const width: string | number = '100%';

  return (
    objectBeingEdited && (
      <SideBar
        open={objectBeingEdited != null}
        toggleDrawer={resetCurrentEditObject}
        showSwipeableDrawer={!isMobile}
        width={{
          drawerWidth: width,
          closedDrawerWidth: 0,
        }}
        anchor="right"
        belowTopBar={!isMobile}
        disableSwipe={!isMobile}
        iOS={iOS}
        animationsDisabled={animationsDisabled}
        theme={theme}
      >
        <>
          {!isMobile && <Toolbar />}
          <EditComponent currentObject={objectBeingEdited} resetObject={resetCurrentEditObject} />
        </>
      </SideBar>
    )
  );
};

export default EditSidebar;
